import { useState, useEffect, useRef } from 'react';

const useToggle = () => {
  const [isOpen, setIsOpen] = useState(false);
  return {
    hide: () => setIsOpen(false),
    isOpen,
    show: () => setIsOpen(true),
    toggle: () => setIsOpen(!isOpen)
  };
};
const useOutsideClick = (ref, callback) => {
  useEffect(() => {
    function handleClickOutside(event) {
      const refs = [];
      if (ref && !Array.isArray(ref)) {
        refs.push(ref);
      } else {
        refs.push(...ref);
      }
      if (!document.contains(event.target))
        return;
      const clickedInside = refs.some((ref2) => {
        return ref2.current && ref2.current.contains(event.target);
      });
      if (!clickedInside) {
        callback(event);
      }
    }
    window.addEventListener("click", handleClickOutside);
    return () => {
      window.removeEventListener("click", handleClickOutside);
    };
  }, [ref, callback]);
};
const useKeyUp = (eventKey, callback) => {
  useEffect(() => {
    const upHandler = (event) => {
      if (event.key === eventKey) {
        callback(event);
      }
    };
    window.addEventListener("keyup", upHandler);
    return () => {
      window.removeEventListener("keyup", upHandler);
    };
  }, [eventKey, callback]);
};
const useIsOverflow = (ref) => {
  const [isOverflow, setIsOverflow] = useState(false);
  const observer = useRef();
  useEffect(() => {
    if (ref.current) {
      observer.current = new ResizeObserver(() => {
        setIsOverflow(ref.current.scrollWidth > ref.current.clientWidth);
      });
      observer.current.observe(ref.current);
    }
    return () => {
      if (observer.current) {
        observer.current.disconnect();
      }
    };
  }, [ref]);
  return isOverflow;
};

export { useIsOverflow, useKeyUp, useOutsideClick, useToggle };
